import { forEach, debounce } from "lodash";
import Patient from "@/services/patient.js";

export default {
    methods: {
        getDefaultOptions(isSimple) {
            if (isSimple) {
                return [
                    {
                        value: 1,
                        text: "Create new record"
                    }
                ];
            }
            return [
                {
                    value: 0,
                    text: "Select source of lab (required)",
                    disabled: true
                },
                {
                    value: 1,
                    text: "Create new record"
                }
            ];
        },
        searchPatients: debounce(async (search, self) => {
            if (search === "") {
                return;
            }

            const res = await self.$http.get(
                `${process.env.BARRAMUNDI}patient/search-patient`,
                {
                    params: {
                        query: search
                    }
                }
            );

            const { message, resources } = res.data.response;

            if (message.code === 200) {
                self.patientListOptions = self.generatePatientList(resources);
            } else {
                self.patientListOptions = [];
            }
        }, 350),
        generatePatientList(records = []) {
            let result = [];

            for (const patient of records) {
                result.push({
                    label: `${patient.fullname} (${patient.index})`,
                    id: patient.id,
                    index: patient.index,
                    value: patient.id,
                    owner: patient.owner ? patient.owner : null
                });
            }

            return result;
        },
        getItemId(items, keyText) {
            let list = [];
            let key = keyText ? keyText : "id";

            if (items) {
                if (_.isArray(items)) {
                    forEach(items, function (item) {
                        if (item[key]) {
                            list.push(item[key]);
                        }
                    });
                } else if (_.isObject(items)) {
                    list.push(items[key]);
                }
            }

            return list;
        },
        getOwner(selectedPatient) {
            Patient.getDetails(selectedPatient.id).then(response => {
                if (response.message.code === 200) {
                    selectedPatient.owner =
                        response.resources.primary_owner &&
                        response.resources.primary_owner.length > 0
                            ? response.resources.primary_owner[0]
                            : null;
                }
            });
        },
        processOptions(
            options = null,
            assignedList = null,
            unassignedList = null
        ) {
            if (options) {
                if (_.isArray(options.assigned) && assignedList) {
                    forEach(options.assigned, option => {
                        assignedList.push({
                            value: option.id,
                            text: option.name
                        });
                    });
                }

                if (_.isArray(options.unassigned) && unassignedList) {
                    forEach(options.unassigned, option => {
                        unassignedList.push({
                            value: option.id,
                            text: option.name
                        });
                    });
                }
            }
        }
    }
};
